import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Table, Params } from 'nallian-table-builder-ui';
import { GetOrganisationId, GetRights } from 'nallian-shared-ui/lib/selectors';
import { hasRight } from 'nallian-shared-ui/lib/lib/routesHelper';
import {
  INFINITE_SCROLL,
  FILTER_SETTINGS,
  VEHICLES_RESOURCE,
  PRIVATE_VEHICLES_RESOURCE,
  VEHICLES_ACTIONS,
  DEFAULT_SORT,
} from '../constants';
import apiRoutes from '../../../app/api/routes';
import Country from './table/Country';
import Owner from './table/Owner';
import CountryFilter from './table/CountryFilter';
import OwnerFilter from './table/OwnerFilter';
import CreatedByFilter from './table/CreatedByFilter';

const VehiclesOverviewTable = ({ isPrivate, baseUrl }) => {
  const organisationId = useSelector(GetOrganisationId);
  const rights = useSelector(GetRights);

  const canUpdate = useMemo(() => hasRight(rights, 'vehicles/update'), [rights]);

  return (
    <Table
      infiniteScroll={INFINITE_SCROLL}
      filtered={FILTER_SETTINGS}
      sorted={DEFAULT_SORT}
      resource={isPrivate ? PRIVATE_VEHICLES_RESOURCE : VEHICLES_RESOURCE}
      url={isPrivate ? apiRoutes.privateVehicles({ organisationId }) : apiRoutes.vehicles()}
      rootTableProperty="values"
      pageSize={50}
      noUserSettings
    >
      <Params.String
        link={canUpdate ? `${baseUrl}/${VEHICLES_ACTIONS.DETAILS}/:id` : undefined}
        name="licensePlate"
        width="5.5rem"
        grow
      />
      <Params.Bool name="hasActiveAccessRights" width="5.5rem" grow />
      <Params.String name="type" width="3.5rem" grow />
      <Params.Custom
        content={Country}
        filter={CountryFilter}
        name="countryCode"
        width="10.5rem"
        grow
        noSort
      />
      {!isPrivate && (
        <Params.Custom
          content={Owner}
          compareId="createdById"
          name="createdBy"
          width="5.5rem"
          filter={CreatedByFilter}
          grow
          noSort
        />
      )}
      <Params.Custom
        content={Owner}
        name="owner"
        compareId="ownedById"
        width="5.5rem"
        filter={OwnerFilter}
        grow
        noSort
      />
      <Params.DateTime name="createdOn" width="5.5rem" grow noSort noFilter />
    </Table>
  );
};

VehiclesOverviewTable.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool,
};
VehiclesOverviewTable.defaultProps = { isPrivate: false };

export default VehiclesOverviewTable;
